import { useEffect, useRef } from 'react';

const VoidFn = () => {
  // empty
};

/**
 * When calling external non-react components, and you can't update the function when state changes,
 * use this to proxy the dynamic function with a static function.
 */
export const useConstFunction = <Args extends never[], R, TFn extends ((...args: Args) => R) | null | undefined>(
  fn: TFn = VoidFn as TFn,
): TFn => {
  const functionRef = useRef<TFn>(fn);
  const proxyRef = useRef<TFn>(((...args: Args) => functionRef.current?.(...args)) as TFn);

  useEffect(() => {
    functionRef.current = fn;
  }, [fn]);

  // oxlint-disable-next-line react/refs
  return proxyRef.current;
};
